import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  ProgressBar,
  Table,
  Badge,
  Form,
  Alert,
  Button,
  Modal
} from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import CustomButton from "../../components/button";
import { ReactComponent as ArrowUpRight } from '../../static/images/svg/Arrow up right.svg';
import Select from "react-select";
import SelectDropdown from '../../components/dropdown/index'
import { toast, ToastContainer } from "react-toastify";
import DetailsTable from '../../components/table';
import Footer from '../../components/footer';
import SpinnerComp from "../../components/spinner/index";
import { FaRegMoneyBill1 } from "react-icons/fa6";
import ImageUpload from '../../components/shipment-status-form-canva/image-upload'
import './today-analytics.css'
Chart.register(...registerables);

const Analytics = ({ user }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [riders, setRiders] = useState([]);
  const [selectedRider, setSelectedRider] = useState(null);

  const [totalCharges, SetTotalCharges] = useState(0);
  const [filteredItems, setFilteredItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItem, setTotalItem] = useState();


  const [isAlreadyVendor, setIsAlreadyVendor] = useState(false);




  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false); // State to manage loader/progress



  const pageSize = 8;

  const fetchDashboardData = async (vendorId = "") => {
    const today = new Date().toLocaleString('en-CA', { timeZone: 'Asia/Dubai' }).slice(0, 10);
    const fromDate = `${today}T00:00:00Z`;
    const toDate = `${today}T23:59:59Z`;

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/shipment/dashboard`,
        {
          fromDate,
          toDate,
          vendorId: selectedVendor || null,
          riderId: selectedRider || null,
          isAnalytics: true
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      
      setDashboardData(response.data);
      
      SetTotalCharges(response.data.totalCharges)
      setLoading(false);
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setError("Failed to fetch dashboard data. Please try again later.");
      setLoading(false);
    }
  };

  const fetchVendors = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/users/all-user`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          params: { status: "active", role: "vendor" },
        }
      );
      setVendors(
        response.data.sellers.map((seller) => ({
          value: seller._id,
          label: seller.name,
        }))
      );
    } catch (err) {
      console.error("Error fetching vendors:", err);
    }
  };

  const fetchRiders = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/users/all-user`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          params: { status: "active", role: "rider" },
        }
      );
      
      setRiders(
        response.data.sellers.map((rider) => ({
          value: rider._id,
          label: rider.name,
        }))
      );
    } catch (err) {
      console.error("Error fetching riders:", err);
    }
  };

  const fetchShipments= async ()=>{
    try {
        setLoading(true);
        const today = new Date().toLocaleString('en-CA', { timeZone: 'Asia/Dubai' }).slice(0, 10);
        const fromDate = `${today}T00:00:00Z`;
        const toDate = `${today}T23:59:59Z`;
        
      const response = await axios.get(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/shipment/all`,
        {
          params: {
            page: currentPage,
            pageSize,
            fromDate: fromDate || null,
            toDate: toDate || null,
            vendorId: selectedVendor,
            riderId: selectedRider,
            isAnalytics: true
          },
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      
      
      if (response.status === 200) {
        const { shipments, pagination } = response.data;
        setFilteredItems(shipments);
        setTotalPages(pagination.totalPages);
        setTotalItem(pagination.totalItems)
      }
      
      
    } catch (error) {
      toast.error('Failed to fetch shipments!');
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }

  const handlePayNow = () => setShowModal(true);

  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);

  const handleImageUpload = async () => {    
    if (!selectedFile) {
      toast.error("Please select a file before submitting.");
      return;
    }
    const toPay = totalCharges || 0
    const formData = new FormData();
    formData.append("image", selectedFile);
    formData.append("toPay", toPay);
    formData.append("vendor", selectedVendor);
    formData.append("status", "Paid");

    try {
      setUploading(true); // Show loader and freeze the screen
      // Dummy API call for image upload
      const response = await axios.post(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/transection/create`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      toast.success("Payment made successfully!");
      setShowModal(false);
      isAlready()
      setSelectedFile(null);
    } catch (error) {
      setSelectedFile(null);
      toast.error("Failed to upload image. Please try again.");
    }finally {
      setUploading(false); // Hide loader
    }
  };

  const isAlready = async () => { 
    const today = new Date().toLocaleString('en-CA', { timeZone: 'Asia/Dubai' }).slice(0, 10);
    const fromDate = `${today}T00:00:00Z`;
    const toDate = `${today}T23:59:59Z`;
    try {
      setIsAlreadyVendor(false)
      // Dummy API call for image upload
      const response = await axios.post(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/transection/get`,
        {
          vendorId: selectedVendor,
          fromDate,
          toDate
        },
        {
          params: {
            page: currentPage,
            pageSize,

          },
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );            
      if (user.role=="admin") {
        if (response.data.transaction.length !== 0) {
          if (response.data.transaction[0].status=="Paid") {
            
            setIsAlreadyVendor(true)
          }
        }
      }
      else if (user.role === "vendor") {
        const hasPaidTransaction = response.data.transaction.some(
          (element) => element.vendor.email === user.email && element.status === "Paid"
        );
      
        if (hasPaidTransaction) {
          setIsAlreadyVendor(true);
        }
      }
      
      
      
    } catch (error) {
      console.error("Please try again.");
    }
  }
  const cancel = ()=>{
    setShowModal(false)
    setSelectedFile(null);

  }


  useEffect(() => {
    fetchDashboardData();
    fetchShipments()
    if (user.role === "admin") {
      fetchVendors();
      fetchRiders()
    }
    if (selectedVendor || user.role === 'vendor') {
      isAlready()
    }
  }, [currentPage, selectedVendor, selectedRider]);

  const handleVendorFilter = (e) => {
    const vendorId = e.target.value;
    setSelectedVendor(vendorId);

    fetchDashboardData(vendorId);
  };

  if (loading) return <SpinnerComp />;


  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }
  
  const {
    totalShipments = 0, // Provide default value 0 if null or undefined
    pendingShipments = 0,
    completedShipments = 0,
    cancelledShipments = 0,
    pendingDetails = {}, // Provide default empty object if null or undefined
  } = dashboardData || {}; // Ensure dashboardData is not null or undefined
  

  const graphData = {
    labels: [
      "Total",
      "Completed",
      "Pending (In Transit)",
      "Pending (Rescheduled)",
      "Pending (Inactive)",
      "Cancelled",
    ],
    datasets: [
      {
        label: "Number of Shipments",
        data: [
          totalShipments,
          completedShipments,
          pendingDetails.inTransit,
          pendingDetails.rescheduled,
          pendingDetails.inactive,
          cancelledShipments,
        ],
        backgroundColor: [
          "#90AFC5",
          "#679560",
          "#408EC6",
          "#6c757d",
          "#ff7f0e",
          "#7A2048",
        ],
      },
    ],
  };

  const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `Shipments: ${context.raw}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 10,
        },
      },
    },
  };
  const columns = [
    {
      header: 'Barcode#',
      render: (item) => item.shipmentId,
    },
    {
      header: 'Status',
      render: (item) => item.status,
    },
    {
      header: 'Rider',
      render: (item) => item.rider? item.rider.name:"Not Assigned",
    },
    {
      header: 'Receiver',
      render: (item) => item.receiverName,
    },
    {
      header: 'Charges',
      render: (item) => item.charges,
    },
    {
      header: 'Date',
      render: (item) => new Date(item.createdAt).toLocaleString('en-GB', { timeZone: 'Asia/Dubai' }),
    },


  ];
  const handleSelectDropDown= (selected)=>{
          
    try {
      if (selected) {
        setSelectedVendor(selected.value);
      } else {
        setSelectedVendor(null);
      }
    } catch (error) {
      console.error("Error handling vendor selection:", error);
    }
  }

  const handleSelectDropDownRider= (selected)=>{
          
    try {
      if (selected) {
        setSelectedRider(selected.value);
      } else {
        setSelectedRider(null);
      }
    } catch (error) {
      console.error("Error handling vendor selection:", error);
    }
  }
  return (
    <Container fluid className="p-4 bg-light">
      <h2 className="mb-2 mt-1 fw-bold" style={{ color: "#005A9C" }}>
        Todays Analytics
      </h2>
      <br/>
      <ToastContainer />

      {user.role === "admin" && (
        <Row className="mb-4">
          <Col md={6}>

          <SelectDropdown
              options={vendors.map((vendor) => ({ value: vendor.value, label: vendor.label }))}
              value={selectedVendor}
              onChange={handleSelectDropDown}
              label="Merchant"
              controlId="vendor"
              placeholder="Select Merchant..."
              isClearable={true}
              isSearchable={true}
            />
          </Col>
          <Col md={6}>

          <SelectDropdown
              options={riders.map((rider) => ({ value: rider.value, label: rider.label }))}
              value={selectedRider}
              onChange={handleSelectDropDownRider}
              label="Rider"
              controlId="rider"
              placeholder="Select rider..."
              isClearable={true}
              isSearchable={true}
            />
          </Col>
        </Row>
      )}

      <Row className="mb-4 g-4">
        <Col md={3}>
          <Card className="shadow-sm text-center">
            <Card.Body>
              <h5 style={{ color: "#90AFC5" }}>Total Shipments</h5>
              <h2 className="display-4" style={{ color: "#90AFC5" }}>
                {totalShipments}
              </h2>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow-sm text-center">
            <Card.Body>
              <h5 style={{ color: "#408EC6" }}>Pending Shipments</h5>
              <h2 className="display-4" style={{ color: "#408EC6" }}>
                {pendingShipments}
              </h2>
              <ProgressBar className="mt-3">
                <ProgressBar
                  striped
                  variant="info"
                  now={(pendingDetails.inTransit / pendingShipments) * 100}
                  label="In Transit"
                  key={1}
                />
                <ProgressBar
                  striped
                  variant="secondary"
                  now={(pendingDetails.rescheduled / pendingShipments) * 100}
                  label="Rescheduled"
                  key={2}
                />
                <ProgressBar
                  striped
                  variant="warning"
                  now={(pendingDetails.inactive / pendingShipments) * 100}
                  label="Inactive"
                  key={3}
                />
              </ProgressBar>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow-sm text-center ">
            <Card.Body>
              <h5 style={{ color: "#679560" }}>Completed Shipments</h5>
              <h2 className="display-4" style={{ color: "#679560" }}>
                {completedShipments}
              </h2>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card className="shadow-sm text-center ">
            <Card.Body>
              <h5 style={{ color: "#7A2048" }}>Cancelled Shipments</h5>
              <h2 className="display-4" style={{ color: "#7A2048" }}>
                {cancelledShipments}
              </h2>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
      <Col md={5} className="mb-4 h-full h-100 align-items-center justify-content-center">
          <Card className="shadow-sm text-center">
            <Card.Body>
              <h5 style={{  }}>Total Charges</h5><br/>
              <h2 
                className="display-4" 
                style={{ 
                  color: !isAlreadyVendor && (totalCharges&&totalCharges != 0) ? "#7A2048" : "#679560", // Red if condition true, Green otherwise
                }}
              >
                {`AED ${totalCharges ? totalCharges : "0.0"}`}
              </h2>
              {((selectedVendor!==null || user.role=="vendor") &&<p 
                style={{ 
                  color: !isAlreadyVendor && totalCharges != 0 ? "#7A2048" : "#679560", // Red if condition true, Green otherwise
                }}
              >
                {` ${!isAlreadyVendor && (totalCharges&&totalCharges != 0) ? "Unpaid" : "Paid"}`}
              </p>)}
              <Container className="d-flex justify-content-center">
                {selectedVendor!==null && user.role=="admin" &&<CustomButton isDisabled={isAlreadyVendor || totalCharges==0}  variant="success" onClick={() => handlePayNow()}
                ><FaRegMoneyBill1 /><div className='ml-3'>Pay Now</div></CustomButton>}
              </Container>
            </Card.Body>
          </Card> 
        </Col>
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <h5>Overview</h5>
              <br/>
              <Table striped bordered hover className="mt-3">
                <thead>
                  <tr className="bg-light text-dark">
                    <th>Status</th>
                    <th>Count</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Badge bg="info">In Transit</Badge>
                    </td>
                    <td>{pendingDetails.inTransit}</td>
                    <td>Shipments currently on the way.</td>
                  </tr>
                  <tr>
                    <td>
                      <Badge bg="secondary">Rescheduled</Badge>
                    </td>
                    <td>{pendingDetails.rescheduled}</td>
                    <td>Shipments delayed and rescheduled.</td>
                  </tr>
                  <tr>
                    <td>
                      <Badge bg="warning">Inactive</Badge>
                    </td>
                    <td>{pendingDetails.inactive}</td>
                    <td>Shipments that are panding.</td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      {/* Modal for Image Upload */}
      <Modal show={showModal}  centered>
        <Modal.Header >
          <Modal.Title>Upload Payment Proof</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {uploading ? (
            <div  id="progress-container">
              <p>Uploading, please wait...</p>
              <div id="progress-bar">
                <div id="progress"></div>
              </div>
            </div>
          ) : (
            <ImageUpload handleChange={handleFileChange} />
          )}
        </Modal.Body>
        <Modal.Footer>
          {!uploading && <CustomButton variant="danger" onClick={cancel} >
            Cancel
          </CustomButton>}
          {!uploading && <CustomButton variant="primary" onClick={handleImageUpload} >
            Submit
          </CustomButton>}
        </Modal.Footer>
      </Modal>

      <Row className="mb-4">
        
        
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <h5>Shipments Deatil</h5>
              <br/>
              <div >
                <div className="border" style={{ height: '27rem', overflowY: 'auto' }}>
                  {filteredItems.length === 0 ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                    <Alert className="text-center" style={{ width: '50%', backgroundColor:"#005A9C", color:"white"}}>
                      No shipment found.
                    </Alert>
                    </div>
                  ) : (
                    <DetailsTable isTransparent={true} data={filteredItems} columns={columns} />
                  )}
                </div>
                  <Footer
                    className={'d-flex justify-content-between align-items-center pt-3'}
                    text={`${totalItem} Total Count`}
                    pageSize={8}
                    totalPages={totalPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
              </div>
            </Card.Body>
          </Card>
        </Col>
        </Row>
      <Row>
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <h5>Graphical View</h5>
              <br/>
              <div style={{ height: "500px" }}>
                <Bar data={graphData} options={graphOptions} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Analytics;
